/**
 * Matches Shopify Liquid `| handle` for navigation titles (Nordic transliteration before slugify).
 */
export function navigationTargetHandle(str: string): string {
  return str
    .toLowerCase()
    .trim()
    .replace(/æ/g, 'ae')
    .replace(/ø/g, 'oe')
    .replace(/å/g, 'aa')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}
